import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";

//ol
import "ol/ol.css";

//amplify
import Amplify from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "us-east-1",
    userPoolId: "us-east-1_MhdnPM9fg",
    userPoolWebClientId: "719slpgtt2p07a71v1nnsrs3nl"
  }
});

// amplify config
//Amplify.configure(aws_exports);

ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js